import React from 'react';

export const Footer = () => {
  return (
    <footer className="footer">      
      <h3>Made with 💖 by <a target="_blank" rel="noreferrer" href="https://juliofranco.vercel.app/">Julio Franco.</a></h3>
    </footer>
  );
};
